import { inject } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';
import { GEOLOCATION_TOKEN, GeolocationProvider } from '@core';
import { DashboardMessageId, DashboardMessageQueryResult } from '../../../models/dashboard-message.query-result';

export class DashboardLocationMessageQueryHandler {
  private readonly geolocationProvider: GeolocationProvider = inject(GEOLOCATION_TOKEN);

  message(): Observable<DashboardMessageQueryResult | null> {
    return combineLatest([
      this.geolocationProvider.isLocationServicesEnabled(),
      this.geolocationProvider.isPermissionGranted()
    ]).pipe(map(([isEnabled, isGranted]: [boolean, boolean]) => this.toMessage(isEnabled, isGranted)));
  }

  private toMessage(isEnabled: boolean, isGranted: boolean): DashboardMessageQueryResult | null {
    if (isEnabled && isGranted) {
      return null;
    }

    const isLocationServicesDisabled: boolean = !isEnabled;

    return {
      id: DashboardMessageId.Location,
      priority: 4,
      title: isLocationServicesDisabled ? 'Włącz lokalizację' : 'Nadaj uprawnienia do lokalizacji',
      subtitle: 'Dzięki lokalizacji łatwiej znajdziesz gierki',
      hasIcon: true,
      clickable: true,
      action: 'none'
    };
  }
}
